import { AlarmClock } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import ErrorComponent from "@/components/errors/ErrorComponent";
import { useTenant } from "@/user/services/tenant";
import { isHttpError } from "@/utils/permissions";

import GuestRequestLayout from "./GuestRequestLayout";
import RequestStatusState from "./RequestStatusState";

export function GuestRequestExpired() {
  const { t } = useTranslation("application.user");
  const tenant = useTenant();
  const company = tenant.settings.general?.organization_name?.trim();

  return (
    <GuestRequestLayout variant="status">
      <RequestStatusState
        color="warning"
        icon={<AlarmClock className="size-6" />}
        title={t("This link has expired")}
        description={
          company
            ? t(
                "To receive a new link, contact the HR department of {{company}}.",
                { company },
              )
            : t("To receive a new link, contact the HR department.")
        }
      />
    </GuestRequestLayout>
  );
}

export function GuestRequestError({ error }: { error: Error }) {
  if (isHttpError(error) && error.statusCode === 403) {
    return <GuestRequestExpired />;
  }

  return <ErrorComponent error={error} />;
}

export function GuestRequestPending() {
  return (
    <GuestRequestLayout>
      <div className="flex flex-1 items-center justify-center">
        <div className="h-8 w-48 animate-pulse rounded-lg bg-gray-200" />
      </div>
    </GuestRequestLayout>
  );
}
